import React from "react";
import { Form } from "react-bootstrap";

const UseFormSwitch = ({ title, field, register, watch, disable }) => {
  return (
    <div className="d-flex">
      <Form.Check
        type="switch"
        id="custom-switch"
        className="me-2"
        {...register(field)}
        disabled={disable}
      />
      <div>{title}</div>
    </div>
  );
};

export default UseFormSwitch;
